<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <div class="searchBox">
            <el-button type="primary" @click="add">添加</el-button>
        </div>
        <div class="dataBox">
            <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                <el-table-column prop="name" label="规格名称" sortable="custom"></el-table-column>
                <el-table-column prop="y_price" label="原价" sortable="custom" width="100px"></el-table-column>
                <el-table-column prop="price" label="现价" sortable="custom" width="100px"></el-table-column>
                <el-table-column prop="price_tuan" label="团购价" sortable="custom" width="100px"></el-table-column>
                <el-table-column prop="order_index" label="排序" sortable="custom" width="100px"></el-table-column>
                <el-table-column label="操作" width="160" align="center">
                    <template slot-scope="scope">
                        <el-button  size="mini" plain type="primary" @click="edit(scope.index, scope.row)">编辑</el-button>
                        <el-button  size="mini" plain type="danger" @click="del(scope.index, scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <Edit
            width="600px"
            :id="model_id"
            :title="edit_title"
            :goods_id="goods_id"
            :isshow="editshow"
            @on-close="closeEditDialog"
            @on-save-ok="saveOk">
        </Edit>
    </el-dialog>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import Edit from "./edit"
import listutil from "@/libs/listutil"

export default {
    name: 'goodsSpecList',
    mixins: [listutil],
    components: {Edit, Btns, LabBtns},
    props: {
        isshow: {
            type: Boolean,
            default() {
                return false;
            }
        },
        goods_id: {
            type: Number,
            default() {
                return -1;
            }
        },
        title: {
            type: String,
            default() {
                return ""
            }
        },
        width: {
            type: String,
            default() {
                return '800px';
            }
        }
    },
    watch: {
        isshow(newv, old) {
            this.showflag = newv;
            if (newv) {
                this.search_Obj.f_goods_id = this.goods_id
                this.getData();
            }
        }
    },
    mounted() {},
    data() {
        return {
            showflag: false,
            m_name: '商品规格',
            menu_id: 9999,
            list_url: "/api/admin/goodsspec/list",
            search_Obj: {
                f_goods_id: 0,
            },
            del_Obj:{
                url:'/api/admin/goodsspec/del',
                data:{
                    ids:''
                }
            },
            enu_name: [],
            sortData: {
                prop: 'order_index',
                order: 'ascending'
            },
        };
    },
    methods: {
        closeDialog() {
            this.$emit("on-close")
        },
    }
};
</script>